import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Sei sicuro?',
    },
    [OrderMethod.Pickup]: "Il cliente ha già ritirato l'ordine?",
    [OrderMethod.OnSite]: "Il cliente ha già ritirato l'ordine?",
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: "L'ordine è già stato consegnato?",
      [DeliveryProvider.UberDrive]: "Il corriere ha già ritirato l'ordine?",
      [DeliveryProvider.FirstDelivery]: "Il corriere ha già ritirato l'ordine?",
      [DeliveryProvider.WoltDrive]: "Il corriere ha già ritirato l'ordine?",
    },
  },
  buttons: {
    cancel: 'No, Annulla',
    confirm: 'Sì',
  },
};
